import { RouterRootState } from "connected-react-router";
import { FC, ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import FloorsTab from "../../../containers/floors-tab";
import { useLocale } from "../../../contexts/localeContext";
import Restricted from "../../../contexts/PermissionProvider/RestrictedWrapper";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useTabCount } from "../../../hooks/useCategoryTab";
import plusIcon from "../../../images/Plus.svg";
import { Category } from "../../../models/Category";
import { Filter } from "../../../models/Filter";
import { showError } from "../../../services/utilities/ServiceError";
import { getListOfSiteIdsFromFilter } from "../../../utilities/tabUtils";
import { toast } from "react-toastify";

const getRouteNameFromPath = (path: string) => {
    const splitPath = path.split('/');
    return splitPath[splitPath.length - 1];
}
const Floors: FC = () => {
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false);
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const { translate } = useLocale();
    const routeName = useSelector((state: RouterRootState) =>
        getRouteNameFromPath(state.router.location.pathname),
    );

    const { updateTabCount } = useTabCount({
        tableName: "Floor",
        categories,
        setCategories,
    });

    const buildCategoriesData = async () => {
        try {
            setBusy(true);
            setCategories([
                {
                    displayName: translate.byKey(TranslationKeys.floors),
                    heading: translate.byKey(TranslationKeys.floors),
                    value: "",
                    id: 0,
                    count: 0,
                },
            ]);
            setBusy(false);
        } catch (error) {
            showError(error, toast.warn);
        }
    }

    useEffect(() => {
        buildCategoriesData();
    }, []);

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [
                <FloorsTab setBusy={setBusy} categories={categories} setCategories={setCategories} onFilterChange={onFilterChange} />
            ]
            setTabContent(newTabContent);
        }
    }, [categories]);

    const onFilterChange = (filters: Filter[]) => {
        const siteIds = getListOfSiteIdsFromFilter(filters);
        updateTabCount(siteIds);
    }

    return <ActivityFrame
        busy={busy}
        className="flex flex-grow overflow-y-hidden">
        <div className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
            <Breadcrumb
                path={[
                    {
                        value: "/access-control/hardware",
                        displayName: translate.byKey(TranslationKeys.hardware)
                    },
                    {
                        value:
                            "/access-control/hardware/floors",
                        displayName: translate.byKey(TranslationKeys.floors),
                    },
                ]}
                onClick={(item) => history.push(item.value)} />
            <Tabs
                className="overflow-y-hidden"
                tabs={getTabsListFromLabels(categories)}
                onSelect={(i) => setSelected(i)}
                selected={selected}
                onAdd={() => { }}
                add={false}
                tabStyle={{}}>
                {tabContent[selected]}
                <div className="flex flex-col flex-grow overflow-y-hidden mb-viewport">
                    <div className="flex flex-row justify-end button-cluster">
                        <Restricted to={`add.${routeName}.element`}>
                            <Link
                                to={{
                                    pathname:
                                        "/access-control/hardware/floor/",
                                }}>
                                <button className="flex rounded-lg bg-lime text-white p-2 shadow-lg" id="addFloorsButton" data-cy="addFloorsButton">
                                    <img
                                        src={plusIcon}
                                        className="px-2 w-8 py-1"
                                        alt="" />
                                    <span className="mr-2">{translate.byKey(TranslationKeys.add)}</span>
                                </button>
                            </Link>
                        </Restricted>
                    </div>
                </div>
            </Tabs>
        </div>
    </ActivityFrame>
};

export default Floors;

